import styled, { css } from 'styled-components';

export const Container = styled.span<{
  $overdue: boolean;
  $lastWeek: boolean;
  $noColor: boolean;
}>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  width: 100%;

  overflow: hidden;
  transition: color 200ms;

  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ $lastWeek, $noColor, theme }) =>
    $lastWeek &&
    !$noColor &&
    css`
      color: ${theme.palette.warning.main};
    `};

  ${({ $overdue, $noColor, theme }) =>
    $overdue &&
    !$noColor &&
    css`
      color: ${theme.palette.error.main};
    `};
`;

export const IconContainer = styled.span<{ $isSmall: boolean }>`
  font-size: ${({ $isSmall }) => ($isSmall ? '1rem' : '114.3%')};
  line-height: 62.5%;
`;

export const Label = styled.span`
  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;
